/**
 * Solana configuration — USDC mint addresses per network.
 */

import type { Network } from '@/lib/network';
import { getActiveNetwork } from '@/lib/network/active';

// `local` shares devnet's USDC mint — engineer dev runs against real
// Solana devnet RPC + program ID, only the backend API URL is overridden.
const USDC_MINT: Record<Network, string> = {
  local: 'GwMYubfhtHzP2vNcoDVRbt64T5ruHRpq5w2wCXGMNTB7',
  devnet: 'GwMYubfhtHzP2vNcoDVRbt64T5ruHRpq5w2wCXGMNTB7',
  mainnet: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
};

/** Returns the USDC mint address for the requested or currently active network. */
export function getUsdcMint(network: Network = getActiveNetwork()): string {
  return USDC_MINT[network];
}

export { USDC_MINT };

/** USDC amounts below this (display units) are treated as zero ("dust"). */
export const USDC_DUST_THRESHOLD: number = 0.02;
/** Same threshold in D6 encoding (20_000 = $0.02). */
export const USDC_DUST_THRESHOLD_D6: number = 20_000;

/** USDC D6 scale factor (1 USDC = 10^6 base units). Use this everywhere instead of the literal 1_000_000. */
export const D6_SCALE: number = 1_000_000;

/** D9 scale factor for prices and unitless market/conviction shares. Outcome-token amounts are D6. */
export const D9_SCALE: number = 1_000_000_000;
